import React from 'react';
import { Box } from '@waglabs/box-next';
import { Button } from '@waglabs/button-next';
import { Typography } from '@waglabs/typography';
import { useFormik, } from 'formik';
import { Flex } from './Flex';
import { OutlinedTextField } from './OutlinedTextField';
export var LeadCaptureFormField;
(function (LeadCaptureFormField) {
    LeadCaptureFormField["Email"] = "email";
    LeadCaptureFormField["Name"] = "name";
    LeadCaptureFormField["ZipCode"] = "zipCode";
})(LeadCaptureFormField || (LeadCaptureFormField = {}));
;
export const useLeadCaptureForm = (formikConfig) => {
    const formik = useFormik(formikConfig);
    const { handleChange, handleSubmit, isSubmitting, values, } = formik;
    return {
        form: (React.createElement("form", { onSubmit: handleSubmit },
            React.createElement(Flex, null,
                React.createElement(OutlinedTextField, { required: true, flex: 1, name: LeadCaptureFormField.Name, placeholder: "Name", value: values[LeadCaptureFormField.Name], onChange: handleChange })),
            React.createElement(Flex, { flexWrap: "wrap", mx: "-4px", my: "-6px", mt: "6px", width: "calc(100% + 8px)" },
                React.createElement(OutlinedTextField, { required: true, name: LeadCaptureFormField.Email, px: "4px", py: "6px", placeholder: "Email", width: ['100%', '278px'], onChange: handleChange, type: "email", value: values[LeadCaptureFormField.Email] }),
                React.createElement(OutlinedTextField, { required: true, name: LeadCaptureFormField.ZipCode, px: "4px", py: "6px", placeholder: "Zip Code", width: ['100%', '112px'], value: values[LeadCaptureFormField.ZipCode], onChange: handleChange })),
            React.createElement(Box, { maxWidth: ['100%', '280px'], mt: "16px", mx: "auto" },
                React.createElement(Button, { disabled: isSubmitting, size: "extraLarge", type: "submit", variant: "contained", width: 1 },
                    React.createElement(Typography, { color: "inherit", fontFamily: "inherit", fontSize: "inherit", fontWeight: "inherit", lineHeight: "inherit", variant: "body2", style: {
                            cursor: 'inherit',
                        } }, "Submit"))))),
        formik,
    };
};
